import type { UserAnswerToSend } from '../../../api';
import { LastPageModel } from '../../LastPageView';
import { SurveyStatus } from '../../types';
import type { QuestionModel } from '../QuestionModel';
import type { Survey } from '../Survey';

export const createUserAnswerToSend = (
  formVersionId: Survey['formVersionId'],
  cmId: Survey['cmId'],
  currentQuestionModel: Survey['currentQuestionModel'],
  nextQuestionModel: QuestionModel
): UserAnswerToSend => {
  return {
    id: formVersionId,
    cm_id: cmId,
    status: nextQuestionModel instanceof LastPageModel ? SurveyStatus.SUCCEEDED : SurveyStatus.IN_PROGRESS,
    form_answer: {
      id: currentQuestionModel.question.id,
      comment: currentQuestionModel.userComment,
      form_answers: currentQuestionModel.selectedAnswers.map((a) => ({
        id: a.id,
        answer_date: new Date().toISOString()
      }))
    }
  };
};
